
export class SuperNet {
	idSuperNet: number;
	nombreSuperNet: string;
	idCiudad: number;;
	idSede: number;
	idAmbiente: number;
	ipInicialRango: string;
	idMascara: number;
	indHabilitado: boolean;
	observaciones: string;
	ipDiecisiete: string;
	ipDieciocho: string;
	ipDiecinueve: string;
	ipVeinte: string;
	ipVeintiuno: string;
	ipVeintidos: string;
	ipVeintitres: string;
	ipVeinticuatro: string;
	ipVeinticinco: string;
	ipVeintiseis: string;
	ipVeintisiete: string;
	ipVeintiocho: string;
	ipVeintinueve: string;
	ipTreinta: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/supernet.ts